import { createReducer, on } from '@ngrx/store';

import * as fromModuleModels from '../../models';
import { CustomerStockItemsActions } from '../actions';
import { ErrorsObject } from '../../../shared/utilities/error-utility.utility';
import { getAndHandleBackendErrors } from '../../../shared/utilities/reducer.utility';
import { UserRoleActions } from '../../../application-state/store/actions';

export interface State {
  entities: { [iri: string]: fromModuleModels.CustomerStockItem };
  errors: ErrorsObject;
  loading: boolean;
  loaded: boolean;
}

const initialState = {
  entities: {},
  errors: {},
  loading: false,
  loaded: false
};

export const reducer = createReducer(
  initialState,
  on(
    CustomerStockItemsActions.CreateCustomerStockItem,
    CustomerStockItemsActions.ReadCustomerStockItem,
    CustomerStockItemsActions.UpdateCustomerStockItem,
    state => {
      return {
        ...state,
        loading: true,
        loaded: false
      };
    }
  ),
  on(
    CustomerStockItemsActions.CreateCustomerStockItemSuccess,
    (state, { response }) => {
      const entities = {
        [response['@id']]: response,
        ...state.entities
      };

      return {
        ...state,
        entities,
        loading: false
      };
    }
  ),
  on(
    CustomerStockItemsActions.ReadCustomerStockItemSuccess,
    CustomerStockItemsActions.UpdateCustomerStockItemSuccess,
    (state, { response }) => {
      const entities = {
        ...state.entities,
        [response['@id']]: response
      };

      return {
        ...state,
        entities,
        errors: {},
        loading: false
      };
    }
  ),
  on(
    CustomerStockItemsActions.CreateCustomerStockItemFail,
    CustomerStockItemsActions.ReadCustomerStockItemFail,
    CustomerStockItemsActions.UpdateCustomerStockItemFail,
    (state, { response }) => {
      return {
        ...state,
        errors: getAndHandleBackendErrors(response),
        loading: false
      };
    }
  ),
  on(
    CustomerStockItemsActions.DeleteCustomerStockItemSuccess,
    (state, { iri }) => {
      const { [iri]: removedItem, ...entities }: any = state.entities;

      return {
        ...state,
        entities,
        loading: false
      };
    }
  ),
  on(UserRoleActions.UserRoleCheckFail, state => ({ ...state, loading: false }))
);
